import { render } from "./SeoBrandCell.vue?vue&type=template&id=389d3afc&scoped=true"
import script from "./SeoBrandCell.vue?vue&type=script&lang=js"
export * from "./SeoBrandCell.vue?vue&type=script&lang=js"

import "./SeoBrandCell.vue?vue&type=style&index=0&id=389d3afc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-389d3afc"]])

export default __exports__